import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'af',
    fullName: 'Afrikaans',
    nativeName: 'Afrikaans',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Iets Amazing kom",
    landing_subtitle: "ArgVoid is 'n app- en speletjie-ontwikkelingsateljee. Bly ingeskakel, nuwe dinge kom binnekort!",
    select_language: "Kies Taal",
    search_placeholder: "Soek tale...",
    terms_title: "Diensbepalings",
    policy_title: "Privaatheidsbeleid",
    cookies_title: "Koekiebeleid",
    terms_content: `
        <strong>1. Aanvaarding van Bepalings</strong><br>
        Deur toegang tot ArgVoid te verkry, word hierdie diensbepalings aanvaar. Indien hierdie bepalings nie ooreengekom word nie, moet die diens nie gebruik word nie.<br><br>

        <strong>2. Platformgebruik</strong><br>
        ArgVoid en sy toepassings word "soos dit is" verskaf vir inligtings- en kreatiewe doeleindes. Die diens moet slegs vir wettige doeleindes gebruik word.<br><br>

        <strong>3. Verbode gedrag</strong><br>
        Die uitbuiting van werfkwesbaarhede, strooipos, of poging tot ongemagtigde toegang tot die infrastruktuur is streng verbode.<br><br>

        <strong>4. Vrywaring</strong><br>
        Die platform en dienste kan enige tyd sonder kennisgewing gewysig word. Geen waarborg word verskaf oor die uptyd of beskikbaarheid van die diens nie.
    `,
    policy_content: `
        <strong>1. Inligtingversameling</strong><br>
        Die platform vereis nie tans gebruikersverifikasie of rekeningskepping nie. Geen persoonlike identifiserende inligting (soos name of e-posadresse) word aktief van besoekers ingesamel nie.<br><br>

        <strong>2. Gebruik Data</strong><br>
        Basiese, anonieme ontledings kan ingesamel word om werfverkeer te verstaan en die toepassings te verbeter. Hierdie data is nie aan individuele gebruikeridentiteite gekoppel nie.<br><br>

        <strong>3. Derdepartydienste</strong><br>
        Derdeparty-verskaffers kan gebruik word vir gasheer- en ontledingsdienste. Die privaatheidspraktyke van hierdie onderskeie verskaffers beheer die anonieme data wat op hul infrastruktuur verwerk word.<br><br>

        <strong>4. Datasekuriteit</strong><br>
        Redelike sekuriteitsmaatreëls word geïmplementeer om die platform te beskerm. Geen metode van oordrag oor die internet is egter heeltemal veilig nie.<br><br>
    `,
    cookies_content: `
        <strong>1. Wat is koekies en plaaslike berging?</strong><br>
        Webkoekies en plaaslike blaaierberging is klein datalêers wat op die toestel gestoor word om konfigurasievoorkeure oor besoeke te onthou.<br><br>

        <strong>2. Gebruiksdoel</strong><br>
        Browser LocalStorage word streng gebruik om konfigurasie-instellings te stoor, soos:<br>
        - Taalvoorkeure<br>
        - Gebruikerskoppelvlakkonfigurasie (bv. uitleg of tema-instellings) <br>
        - Tydelike toepassing cache<br><br>

        <strong>3. Geen dop </strong><br>
        Koekies en plaaslike berging word nie vir advertensie- of derdeparty-nasporingsdoeleindes gebruik nie. Alle gestoorde data is streng vir die kernfunksies van die platform.<br><br>

        <strong>4. Beheer</strong><br>
        Blaaierdata kan enige tyd deur die blaaierinstellings uitgevee word, wat enige plaaslike konfigurasies sal terugstel.
    `,
    cookie_consent_text: "Ons gebruik basiese webkoekies om te verseker dat die webwerf korrek funksioneer, soos om jou sessie aktief te hou, jou taalvoorkeur te stoor en ander pasgemaakte konfigurasies.",
    read_policy: "Lees koekiebeleid",
    support_title: "Kontak ondersteuning",
    support_subject_label: "Onderwerp",
    support_message_label: "Boodskap",
    support_submit_button: "Stuur Boodskap",
    support_hint: "Let wel: Dit sal jou verstek e-postoepassing oopmaak om die boodskap te stuur.",
    support_success_msg: "Maak tans jou e-posprogram oop...",
    support_error_msg: "Kon nie boodskap stuur nie. Probeer asseblief later weer.",
    explorer_title: "Verkenner",
    history_title: "Geskiedenis",
    animation_title: "Animasie",
    config_title: "Konfigurasie",
    tool_mouse: "Kies (Ctrl+M)",
    tool_brush: "Borsel (Ctrl+B)",
    tool_brush_mode: "Wisselmodus (Solied/Duidelik)",
    tool_eraser: "Uitveër (Ctrl+E)",
    tool_brush_size: "Pas kwasgrootte aan",
    tool_bucket: "Vul (Ctrl+F)",
    tool_eyedropper: "Piet",
    tool_grid: "Rooster (Ctrl+Shift+B)",
    tool_rotate: "Draai (Ctrl+Shift+R)",
    tool_flip_h: "Draai H (Ctrl+Shift+H)",
    tool_flip_v: "Flip V (Ctrl+Shift+V)",
    tool_transpose: "Transponeer (Ctrl+Shift+T)",
    label_width: "Breedte",
    label_height: "Hoogte",
    label_frames: "Aantal rame",
    label_animation: "Animasie styl",
    label_background_color: "Agtergrondkleur",
    label_interval: "Interval",
    tool_anim_config: "Animasie konfigurasie",
    label_new_width: "Nuwe Breedte",
    label_new_height: "Nuwe Hoogte",
    label_apply: "Doen aansoek",
    label_colors: "Kleure",
    label_size: "Grootte",
    label_tolerance: "Verdraagsaamheid",
    val_horizontal: "Horisontaal",
    val_vertical: "Vertikaal",
    val_sequence: "Volgorde",
    val_bounce: "Weiering",
    val_random: "Willekeurig",
    val_solid: "Solied",
    val_clear: "Duidelik",
    action_add_sheet: "Nuwe Blad",
    action_import: "Invoer",
    action_export: "Uitvoer",
    action_sort_projects: "Sorteer",
    sort_date_old: "Oudste Eerste",
    sort_date_new: "Nuutste eerste",
    sort_name_az: "Naam (A-Z)",
    sort_name_za: "Naam (Z-A)",
    action_new_sprite: "Nuwe Sprite",
    action_new_project: "Nuwe projek",
    modal_save_all_title: "Stoor alle veranderinge",
    modal_save_all_desc: "Kies die bates om te stoor:",
    modal_save_selected: "Stoor geselekteerde",
    action_saved: "Gestoor",
    modal_create_sprite_title: "Skep nuwe Sprite",
    modal_create_project_title: "Skep nuwe projek",
    modal_add_sheet_title: "Voeg nuwe blad by",
    modal_rename_sheet_title: "Hernoem Blad",
    modal_rename_sprite_title: "Hernoem Sprite",
    modal_delete_sprite_title: "Vee Sprite uit",
    modal_delete_project_title: "Vee Projek uit",
    modal_delete_sheet_title: "Vee Blad uit",
    placeholder_sprite_name: "Naam",
    placeholder_project_name: "Naam",
    placeholder_sheet_name: "Naam",
    placeholder_new_name: "Nuwe Naam",
    action_create: "Skep",
    action_add: "Voeg by",
    action_rename: "Hernoem",
    action_duplicate: "Duplikaat",
    action_delete: "Vee uit",
    action_cancel: "Kanselleer",
    confirm_delete_sprite: "Is jy seker jy wil hierdie sprite uitvee?",
    confirm_delete_project: "Is jy seker jy wil hierdie projek uitvee? Alle sprites sal verwyder word.",
    confirm_delete_sheet: "Is jy seker jy wil hierdie blad uitvee?",
    err_select_sprite: "Kies asseblief eers 'n sprite.",
    err_select_project: "Kies asseblief eers 'n projek.",
    err_name_empty: "Naam kan nie leeg wees nie.",
    err_sprite_exists: "'n Sprite met daardie naam bestaan ​​reeds.",
    err_project_exists: "'n Projek met daardie naam bestaan ​​reeds.",
    err_no_content: "Geen inhoud om te stoor nie.",
    err_no_changes: "Geen veranderinge om te stoor nie.",
    err_delete_last_sheet: "Kan nie die laaste blad uitvee nie.",
    err_extract_frames: "Kon geen rame onttrek nie.",
    err_indexeddb: "Kon nie plaaslik stoor nie. Jou blaaier ondersteun dalk nie IndexedDB nie.",
    msg_upload_success: "Oplaai suksesvol: {0}",
    msg_upload_failed: "Oplaai het misluk: {0}",
    msg_save_success: "Stoor suksesvol.",
    msg_saving: "Stoor tans …",
    msg_multi_save_result: "{0} bates gestoor. {1} mislukkings.",
    menu_title: "Spyskaart",
    menu_save: "Stoor",
    menu_save_all: "Stoor alles",
    menu_support: "Kontak ondersteuning",
    label_local_storage: "Plaaslike berging",
    label_sign_in: "Meld aan",
    modal_export_title: "Voer Sprite uit",
    label_filename: "Lêernaam",
    label_format: "Formaat",
    action_export_confirm: "Uitvoer",
};

export default translations;
